
import React from 'react';
import { cn } from '@/lib/utils';

interface ReportLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const ReportLayout = ({ children, className }: ReportLayoutProps) => {
  return (
    <div className={cn(
      "w-full max-w-4xl mx-auto px-3 sm:px-4 md:px-6 space-y-4 sm:space-y-6",
      className
    )}>
      {children}
    </div>
  );
};

export default ReportLayout;
